<template>
    <div class="Header">

        <div class="username">
            <el-button 
                type="warning" 
                size="small" 
                @click="restartSystem" 
                :loading="restartLoading" 
                class="restart-btn"
                title="点击重启服务"
                circle>
                <template #icon>
                    <el-icon size="18"><SwitchButton /></el-icon>
                </template>
            </el-button>
        </div>

        <div class="avatar">
            <div style="margin-top:12px">
                <el-avatar :size="40" :src="userInfo.avatar"/>
            </div>
        </div>

        <div class="username">
            <span>{{userInfo.username}},{{time}}</span>
        </div>
        <div class="layout">
            <span>
                <a href="#" @click="layout()">退出登录</a>
            </span>
        </div>
    </div>
</template>

<script>
    import {ElMessage} from 'element-plus';
    import {Refresh, SwitchButton} from '@element-plus/icons-vue';

    export default {
        name: "Header",
        data() {
            return {
                userInfo: {
                    "username":"admin",
                    "avatar":"https://ziyuan.guwendao.net/authorImg300/xinqiji.jpg"
                },
                time: '',
                restartLoading: false
            }
        },
        mounted() {
            // this.getUserInfo();
            this.getTime();
        },
        methods: {
            layout() {
                window.sessionStorage.removeItem("token");
                window.sessionStorage.removeItem("userInfo");
                this.$router.replace("/");
                ElMessage({
                    message: '退出成功',
                    type: 'success',
                });
            },
            restartSystem() {
                this.$confirm('确定要重启系统吗？重启过程可能需要几分钟时间。', '系统重启', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.restartLoading = true;
                    fetch('/api/system/restart', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'token': window.sessionStorage.getItem('token') || 'pass'
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data.code === '200') {
                            ElMessage.success('重启请求已发送，请稍后刷新页面');
                        } else {
                            ElMessage.error('重启请求失败: ' + (data.msg || '未知错误'));
                        }
                    })
                    .catch(error => {
                        console.error('重启请求失败:', error);
                        ElMessage.error('重启请求失败，服务器可能正在重启');
                    })
                    .finally(() => {
                        this.restartLoading = false;
                    });
                }).catch(() => {
                    ElMessage.info('已取消重启');
                });
            },
            //在sessionStorage获取用户信息
            getUserInfo() {
                const userInfo = window.sessionStorage.getItem('userInfo');
                this.userInfo = JSON.parse(userInfo);
                // this.circleUrl=this.userInfo.avatar;
                console.log("用户信息:" + this.userInfo);
                console.log("用户信息:" + userInfo);

            },
            /**
             * 判断当前时间是上午,下午,晚上
             */
            getTime() {
                let date = new Date();
                if (date.getHours() >= 0 && date.getHours() < 12) {
                    this.time = "上午好"
                } else if (date.getHours() >= 12 && date.getHours() < 18) {
                    this.time = "下午好"
                } else {
                    this.time = "晚上好"

                }
            }
        }
    }
</script>

<style lang="less" scoped>
    a {
        text-decoration: none;
        color: deepskyblue;
    }

    .Header {
        height: 4rem;
        width: 100%;
        background-color: cornflowerblue;
        display: flex;
        justify-content: flex-end;
        line-height: 4rem;
            .avatar {
                line-height: 4rem;
            }
            .username {
                line-height: 4rem;
                margin-left: 20px;
                text-align: center;
                font-size: 14px;
                font-weight: bolder;
                color: white;
                margin-right: 20px;
                display: flex;
                align-items: center;
                gap: 10px;
            }
            .restart-btn {
                margin-top: 2px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;
            }
            .restart-btn:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
            }
            .restart-btn:active {
                transform: translateY(0);
            }
            .layout {
                line-height: 60px;
                font-size: 14px;
                margin-right: 20px;
                font-weight: bolder;
                color: black;
                margin-top: 3px;

            a:hover {
                color: orange;
            }
        }
    }


</style>
